module.exports = __webpack_public_path__ + "img/gb13871-92_38x52x8.prt.98707ea3.jpg";